import React from 'react'
import Tooltip from '../Tooltip'
import ShopOrderTooltip from './tooltips/ShopOrderTooltip'
import CustomerTooltip from './tooltips/CustomerTooltip'
import { BORDER_STYLE } from './SortableOrdersTable'
import { displayCurrency } from '../../utils/utils'
import { Table, Icon } from 'semantic-ui-react'
import $ from 'jquery'
import { RED, GREEN } from '../../constants/colors'
import {
  DETAILS_TAB, INVOICE_TAB, TRANSACTIONS_TAB, LINE_ITEMS_TAB
} from "../../constants/orders"
import ShopOrderDetails from "./ShopOrderDetails";

export default class ReconciliationRow extends React.Component {
  // TODO: refactor this hack
  closeTooltip = () => {
    $(`.OrderRow-${this.props.order.id}`).click()
  }

  render() {
    const { order, originator, vehicle, shop, orderServices, isLastRow, version } = this.props
    const {
      post_tax_total, previous_payments, invoice_reconciliation
    } = order
    const {
      over_retail, tax_inconsistency, customer_braintree_inconsistency, ai_invoice_inconsistency
    } = (invoice_reconciliation || {})
    const missing_mappings = !!order.invoice_line_items.find((i) => !i.order_service_id)
    const membership = originator.active_membership

    const style = isLastRow ? {borderBottom: BORDER_STYLE} : {}
    const tabData = [
      { tab: DETAILS_TAB, label: "Details" },
      { tab: INVOICE_TAB, label: "Invoice Checks" },
      { tab: LINE_ITEMS_TAB, label: "Invoice Mapping" },
      { tab: TRANSACTIONS_TAB, label: "Transactions" },
    ]

    return (
      <Table.Row key={`OrderRow-${order.id}`} className={`OrderRow-${order.id}`}>
        <Table.Cell className="left aligned" style={{...style, cursor: "pointer"}}>
            {version === 'V1' && <ShopOrderTooltip
                order={order}
                customer={originator}
                vehicle={vehicle}
                shop={shop}
                orderServices={orderServices}
                tabData={tabData}
                id={order.id}
            />}
            {version === 'V2' && <Tooltip
                trigger={<span>{order.id}</span>}
                content={
                    <div style={{width: order.is_fixed_price ? "850px" : "750px", cursor: "auto", minHeight: "20px"}}>
                        <ShopOrderDetails id={order.id} customer={originator} tabData={tabData}/>
                    </div>
                }
                infoIcon
                infoIconColor={order.is_fixed_price ? GREEN : 'black'}
            />}
        </Table.Cell>
        <Table.Cell style={{...style, cursor: "pointer"}}>
          <Tooltip
            trigger={<span>{`${originator.full_name} (${originator.completed_orders_count})`}</span>}
            content={<CustomerTooltip customer={originator} />}
            infoIcon
            infoIconColor={membership && membership.price > 0 ? 'blue' : 'black'}
          />
        </Table.Cell>

        <React.Fragment>
          {[missing_mappings, over_retail, ai_invoice_inconsistency, customer_braintree_inconsistency, tax_inconsistency].map(bool =>
            <Table.Cell style={{...style, textAlign: "center"}}>
              <Icon name={bool ? 'minus circle' : 'check circle'} style={{color: bool ? RED : GREEN}} />
            </Table.Cell>
          )}
        </React.Fragment>
        <Table.Cell style={style}>
          {displayCurrency(post_tax_total)}
        </Table.Cell>
        <Table.Cell style={{...style, borderRight: BORDER_STYLE}}>
          {displayCurrency(previous_payments)}
        </Table.Cell>
      </Table.Row>
    )
  }
}
